'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const tslib = require('tslib');
const isSvgComponent = require('./utils/is-svg-component.js');
const useProps = require('../html/use-props.js');
const filterProps = require('./utils/filter-props.js');
const useProps$1 = require('../svg/use-props.js');

function createUseRender(Component, forwardMotionProps) {
  if (forwardMotionProps === void 0) {
    forwardMotionProps = false;
  }
  var useRender = function (props, ref, _a, isStatic) {
    var latestValues = _a.latestValues;
    var useVisualProps = isSvgComponent.isSVGComponent(Component) ? useProps$1.useSVGProps : useProps.useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic);
    var filteredProps = filterProps.filterProps(props, typeof Component === "string", forwardMotionProps);
    var elementProps = tslib.__assign(tslib.__assign(tslib.__assign({}, filteredProps), visualProps), {
      ref: ref
    });
    return React.createElement(Component, elementProps);
  };
  return useRender;
}

exports.createUseRender = createUseRender;
